<template>
  <div class="upgrade-box">
    <div v-if="isPC" class="upgrade f-b-c">
      <img src="https://img.kakaclo.com/web-img/system_img.svg" alt="">
      <!-- <div>{{ $t('Components.Common.UpgradeBox.Tips1') }}</div> -->
      <div>System update is processing</div>
      <el-button type="primary" @click="removeUpgrade" style="width:160px;height:40px">OK</el-button>
    </div>
    <div v-else class="upgrade f-b-c upgrade-mobile">
      <img src="https://img.kakaclo.com/web-img/system_img.svg" alt="">
      <!-- <div>{{ $t('Components.Common.UpgradeBox.Tips1') }}</div> -->
      <div>System update is processing</div>
      <el-button type="primary" @click="removeUpgrade" style="width:3rem;height:.76rem">OK</el-button>
    </div>
  </div>
</template>

<script>
import API from '@/api'
import store from '@/store'
export default {
  computed: {
    isPC() {
      return document.body.offsetWidth > 1000
    }
  },
  methods: {
    removeUpgrade() {
      document.querySelectorAll('.upgrade-box').forEach(item => {
        item.remove()
        this.logOut()
      })
    },
    logOut() {
      API.logout().finally(() => {
        store.dispatch('logOut')
        location.reload(true)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upgrade-box {
  position: fixed;
  background: rgba(0, 0, 0, .4);
  width: 100%;
  height: 100%;
  z-index: 3000;
  top: 0;
  .upgrade {
    width: 500px;
    height: 300px;
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 6px;
    flex-direction: column;
    padding: 70px 0 40px 0;
    img {
      width: 66px;
      height: 78px;
    }
  }
  .upgrade-mobile {
    padding: .7rem 0;
    width: 6rem;
    height: 5.2rem;
    img {
      width: 1.32rem;
      height: 1.56rem;
    }
  }
}
</style>
